<template>
  <b-sidebar
    id="add-new-contract-sidebar"
    :visible="isAddNewContractSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    :right="$i18n.locale === 'ar'"
    @hidden="resetData"
    @change="(val) => $emit('update:is-add-new-contract-sidebar-active', val)"
  >

    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ $t('Create New Contract')}}
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />

      </div>

      <div class="loading_page" v-if="requestStatus">
        <orbit-spinner
            :animation-duration="1000"
            :size="100"
            :color="'#0e96b1'"
        />
      </div>

      <!-- BODY -->
        <!-- Form -->
        <b-form
          class="p-2"
          @submit.prevent="onSubmit">

          <!-- Name -->
            <b-form-group :label="$t('Name')" label-for="ar_name">
              <b-form-input
                id="name"
                v-model="contractData.name"
                autofocus
                :state="errors && !('name' in errors)"
                trim
                autocomplete="off"
                :placeholder="$t('Name')"
              />

              <b-form-invalid-feedback v-if="errors && ('name' in errors)" :state="errors && ('name' in errors) ? false : null">
                {{ errors.name[0]  }}
              </b-form-invalid-feedback>

            </b-form-group>


            <b-form-group :label="$t('Contractor')" label-for="Contractor">
              <v-select
                v-model="contractData.contractor_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="contactors"
                :getOptionLabel="c => c.name"
                :reduce="c => c.id"
                :clearable="false"
                input-id="Contractor"
              />
              <b-form-invalid-feedback v-if="errors && ('contractor_id' in errors)" :state="errors && ('contractor_id' in errors) ? false : null">
                {{ errors.contractor_id[0] }}
              </b-form-invalid-feedback>
            </b-form-group>

          <!-- Color -->
          <b-form-group :label="$t('Color')" label-for="color">
            <b-form-input
                id="color"
                type="color"
                v-model="contractData.color"
                autofocus
                :state="errors && ('color' in errors) ? false : null"
                trim
                autocomplete="off"
                :placeholder="$t('Color')"
            />

            <b-form-invalid-feedback v-if="errors && ('color' in errors)" :state="errors && ('color' in errors) ? false : null">
              {{ errors.color[0] }}
            </b-form-invalid-feedback>

          </b-form-group>


          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit">
              {{ $t('Save')}}
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="resetData">
              {{ $t('Reset') }}
            </b-button>
          </div>
        </b-form>

    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton,
  BFormTextarea
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import store from '@/store'
import flatPickr from 'vue-flatpickr-component'
import { OrbitSpinner } from 'epic-spinners'

import useGroupEdit from '@/views/modules/group/groups-edit/useGroupEdit'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormTextarea,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    vSelect,
    OrbitSpinner,

    flatPickr,

  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isAddNewContractSidebarActive',
    event: 'update:is-add-new-contract-sidebar-active',
  },
  props: {
    isAddNewContractSidebarActive: {
      type: Boolean,
      required: true,
    },

  },
  setup(props, { emit, root }) {

    const blankData = {
      name: '',
      contractor_id: '',
      color: '#4d8aeb'
    }


    const errors = ref(null)

    const requestStatus = ref(false)

    const contactors = ref([])

    const contractData = ref(JSON.parse(JSON.stringify(blankData)))
    const resetData = () => {
      contractData.value = JSON.parse(JSON.stringify(blankData))
    }



    store.dispatch('contracts/fetchContactors', {
      type: 'user',
      user: store.state.auth.userData.id
    }).then(res => contactors.value = res.data.data)


    const onSubmit = () => {

      requestStatus.value = true
      errors.value = null

      store.dispatch('contracts/createContract', contractData.value)
        .then(() => {
          requestStatus.value = false
          emit('refetch-data')
          emit('update:is-add-new-contract-sidebar-active', false)
          toaster('Contract Created Successfully')
        }).catch(res => {
          requestStatus.value = false
          if (res.response?.status === 422) {
            errors.value = res.response.data.errors
          }
        })
    }


    return {
      contactors,
      contractData,
      onSubmit,
      resetData,
      requestStatus,
      errors
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
#add-new-contract-sidebar{
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
